import ShowAllTab from 'components/collaborator/collaborator/tabs/show_all';
import React, { useState } from 'react';

const PackageHealthCheck = ({ hashed_id }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    setIsLoading(true);

    try {
      const response = await fetch('/super/package_info/health_check', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hashed_id }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw error;
      }

      const data = await response.json();
      swal({
        title: 'Health Check in Progress',
        text: "We will check the package documents and email you the results when it's done",
        type: "success",
      })
    } catch (error) {
      console.error('Health check failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container" style={{ paddingLeft: 0 }}>
      <div className="col-xs-2">
        <button
          className="btn btn-warning"
          style={{ width: '135px' }}
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? 'Checking...' : 'Check Health'}
        </button>
      </div>
    </div>
  );
};

export default PackageHealthCheck;
